import {StyledSlider} from "../../../components"

export const Cotton22StyledSlider = StyledSlider

export default Cotton22StyledSlider
